import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "trezo-card bg-white p-[20px] md:p-[25px] rounded-md"
}
const _hoisted_2 = {
  key: 1,
  class: "trezo-card bg-white p-[20px] md:p-[25px] rounded-md"
}
const _hoisted_3 = { class: "text-center p-10" }
const _hoisted_4 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_5 = {
  key: 2,
  class: "trezo-card bg-white p-[20px] md:p-[25px] rounded-md"
}
const _hoisted_6 = { class: "text-center p-10" }
const _hoisted_7 = {
  key: 3,
  class: "trezo-card bg-white p-[20px] md:p-[25px] rounded-md overflow-hidden"
}
const _hoisted_8 = { class: "trezo-card-content" }
const _hoisted_9 = { class: "w-[calc(100%+40px)] md:w-[calc(100%+50px)] bg-primary-500 shadow-md p-4 mb-1 -mx-[20px] md:-mx-[25px] mt-[-20px] md:mt-[-25px]" }
const _hoisted_10 = {
  key: 0,
  class: "text-xl font-medium text-center text-white"
}
const _hoisted_11 = { class: "relative rounded-md" }
const _hoisted_12 = { class: "relative overflow-hidden rounded-md" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "absolute bottom-[10px] right-[10px] bg-black bg-opacity-60 text-white text-xs py-1 px-2 rounded"
}
const _hoisted_15 = {
  key: 0,
  class: "flex mt-2 overflow-x-auto pb-2 space-x-2"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "relative w-full max-w-6xl p-4" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = {
  key: 2,
  class: "absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-60 text-white py-1 px-3 rounded-full text-sm"
}
const _hoisted_21 = { class: "text-lg mb-[9px] mt-[20px] text-primary-500" }
const _hoisted_22 = { class: "block relative pt-px ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_23 = { class: "mt-[17px] sm:flex items-center justify-between py-[10px] border-y border-primary-50 dark:border-[#172036]" }
const _hoisted_24 = { class: "mb-[10px] sm:mb-0" }
const _hoisted_25 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_26 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_27 = { class: "relative inline-block relative ltr:pl-[24px] rtl:pr-[24px] ltr:mr-[20px] rtl:ml-[20px] ltr:last:mr-0 rtl:last:ml-0" }
const _hoisted_28 = {
  key: 0,
  class: "inline-block text-xs rounded-[4px] py-1 px-3 bg-primary-100 dark:bg-primary-900 text-primary-700 dark:text-primary-300"
}
const _hoisted_29 = {
  key: 3,
  class: "text-md md:text-lg mt-[20px] md:mt-[25px] lg:mt-[30px] mb-[12px]"
}
const _hoisted_30 = { key: 4 }
const _hoisted_31 = {
  key: 6,
  class: "mt-6"
}
const _hoisted_32 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_33 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_34 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_35 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_36 = {
  key: 3,
  class: "flex items-center"
}
const _hoisted_37 = {
  key: 4,
  class: "flex items-center"
}
const _hoisted_38 = {
  key: 5,
  class: "flex items-center"
}
const _hoisted_39 = {
  key: 6,
  class: "flex items-center"
}
const _hoisted_40 = {
  key: 7,
  class: "flex items-center"
}
const _hoisted_41 = {
  key: 8,
  class: "flex items-center"
}
const _hoisted_42 = {
  key: 9,
  class: "flex items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[12] || (_cache[12] = [
        _createElementVNode("div", { class: "flex justify-center items-center p-20" }, [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500 opacity-75" })
        ], -1)
      ])))
    : (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-danger-500 text-3xl mb-3" }, [
              _createElementVNode("i", { class: "ri-error-warning-line" })
            ], -1)),
            _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-xl font-medium mb-2 text-danger-500" }, "Error Loading Property", -1)),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/real-estate/property-list'))),
              class: "inline-block mt-4 font-medium px-5 py-2 rounded-md bg-primary-500 text-white hover:bg-primary-400 transition-colors"
            }, " Back to Property List ")
          ])
        ]))
      : (!_ctx.property)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-gray-400 text-3xl mb-3" }, [
                _createElementVNode("i", { class: "ri-building-line" })
              ], -1)),
              _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-xl font-medium mb-2 text-gray-700 dark:text-gray-300" }, "Property Not Found", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-gray-500 dark:text-gray-400" }, "The property you're looking for doesn't exist or has been removed.", -1)),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/real-estate/property-list'))),
                class: "inline-block mt-4 font-medium px-5 py-2 rounded-md bg-primary-500 text-white hover:bg-primary-400 transition-colors"
              }, " Back to Property List ")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.property.title)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_10, _toDisplayString(_ctx.formatTitle(_ctx.property.title)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: _ctx.currentImage || _ctx.placeholderImage,
                    class: "inline-block rounded-md w-full h-auto object-cover cursor-pointer",
                    alt: "property-details-image",
                    onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args))),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLightbox(_ctx.currentImageIndex)))
                  }, null, 40, _hoisted_13),
                  (_ctx.allImages.length > 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevImage && _ctx.prevImage(...args)), ["prevent"])),
                          class: "absolute left-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-r cursor-pointer hover:bg-opacity-70 transition-all z-10",
                          "aria-label": "Previous image"
                        }, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "ri-arrow-left-s-line text-2xl" }, null, -1)
                        ])),
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextImage && _ctx.nextImage(...args)), ["prevent"])),
                          class: "absolute right-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-l cursor-pointer hover:bg-opacity-70 transition-all z-10",
                          "aria-label": "Next image"
                        }, _cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "ri-arrow-right-s-line text-2xl" }, null, -1)
                        ]))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["absolute top-[20px] ltr:right-[20px] rtl:left-[20px] inline-block text-xs rounded-[4px] py-px px-[10px]", _ctx.property.rent_or_sale === 'rent' ? 'bg-secondary-100 text-secondary-600' : 'bg-success-100 text-success-600'])
                  }, _toDisplayString(_ctx.property.rent_or_sale === 'rent' ? 'Rent' : 'Sale'), 3),
                  (_ctx.allImages.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.currentImageIndex + 1) + "/" + _toDisplayString(_ctx.allImages.length), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.galleryImages.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allImages, (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(["flex-shrink-0 w-[80px] h-[60px] rounded-md overflow-hidden cursor-pointer transition-all", { 'ring-2 ring-primary-500': _ctx.currentImageIndex === index }]),
                          onClick: ($event: any) => (_ctx.setCurrentImage(index))
                        }, [
                          _createElementVNode("img", {
                            src: image,
                            class: "w-full h-full object-cover",
                            alt: `Property image ${index + 1}`,
                            onError: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleThumbnailError($event)))
                          }, null, 40, _hoisted_17)
                        ], 10, _hoisted_16))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.lightboxOpen)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center transition-opacity",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args)), ["self"]))
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args))),
                        class: "absolute top-2 right-2 text-white text-2xl bg-black bg-opacity-50 rounded-full w-10 h-10 flex items-center justify-center hover:bg-opacity-70 z-10",
                        "aria-label": "Close lightbox"
                      }, _cache[20] || (_cache[20] = [
                        _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                      ])),
                      (_ctx.allImages.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevLightboxImage && _ctx.prevLightboxImage(...args)), ["prevent"])),
                            class: "absolute left-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full cursor-pointer hover:bg-opacity-70 transition-all z-10",
                            "aria-label": "Previous image"
                          }, _cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "ri-arrow-left-s-line text-2xl" }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      (_ctx.allImages.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextLightboxImage && _ctx.nextLightboxImage(...args)), ["prevent"])),
                            class: "absolute right-4 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full cursor-pointer hover:bg-opacity-70 transition-all z-10",
                            "aria-label": "Next image"
                          }, _cache[22] || (_cache[22] = [
                            _createElementVNode("i", { class: "ri-arrow-right-s-line text-2xl" }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        src: _ctx.allImages[_ctx.lightboxIndex],
                        class: "max-h-[80vh] max-w-full mx-auto object-contain",
                        alt: `Property image ${_ctx.lightboxIndex + 1}`,
                        onError: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                      }, null, 40, _hoisted_19),
                      (_ctx.allImages.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.lightboxIndex + 1) + "/" + _toDisplayString(_ctx.allImages.length), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.formattedPrice), 1),
              _createElementVNode("span", _hoisted_22, [
                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "material-symbols-outlined text-primary-500 absolute ltr:-left-[2px] rtl:-right-[2px] top-1/2 -translate-y-1/2 !text-[19px]" }, " location_on ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.property.address), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("ul", _hoisted_24, [
                  _createElementVNode("li", _hoisted_25, [
                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " bed ", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.property.bedroom || '0') + "Bed ", 1)
                  ]),
                  _createElementVNode("li", _hoisted_26, [
                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " bathtub ", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.property.bathroom || '0') + "Bath ", 1)
                  ]),
                  _createElementVNode("li", _hoisted_27, [
                    _cache[26] || (_cache[26] = _createElementVNode("i", { class: "material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-primary-500 !text-[18px]" }, " square_foot ", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.property.size || '0') + "sqft ", 1)
                  ])
                ]),
                (_ctx.property.property_type)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.property.property_type), 1))
                  : _createCommentVNode("", true)
              ]),
              _cache[44] || (_cache[44] = _createElementVNode("h3", { class: "text-md md:text-lg mt-[20px] md:mt-[25px] lg:mt-[30px] mb-[12px]" }, " Description ", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.property.description || 'No description available.'), 1),
              (_ctx.features.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-md md:text-lg mt-[20px] md:mt-[25px] lg:mt-[30px] mb-[12px]" }, " Features ", -1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "relative ltr:pl-[17px] rtl:pr-[17px] mb-[10px] last:mb-0"
                        }, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-[7px] h-[7px] rounded-full bg-primary-500 mt-px" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(feature), 1)
                        ]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.neighborhoodInfo.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "text-md md:text-lg mt-[20px] md:mt-[25px] lg:mt-[30px] mb-[12px]" }, " Neighborhood ", -1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.neighborhoodInfo, (info, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "relative ltr:pl-[17px] rtl:pr-[17px] mb-[10px] last:mb-0"
                        }, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-[7px] h-[7px] rounded-full bg-primary-500 mt-px" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(info), 1)
                        ]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.property.country || _ctx.property.city)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_29, " Location "))
                : _createCommentVNode("", true),
              (_ctx.property.country || _ctx.property.city)
                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString([_ctx.property.city, _ctx.property.country].filter(Boolean).join(', ')), 1))
                : _createCommentVNode("", true),
              (_ctx.renovations.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "text-md md:text-lg mt-[20px] md:mt-[25px] lg:mt-[30px] mb-[12px]" }, " Recent Renovations ", -1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renovations, (renovation, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: "relative ltr:pl-[17px] rtl:pr-[17px] mb-[10px] last:mb-0"
                        }, [
                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 w-[7px] h-[7px] rounded-full bg-primary-500 mt-px" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(renovation), 1)
                        ]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.hasAdditionalDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "text-md md:text-lg mb-[12px]" }, "Additional Details", -1)),
                    _createElementVNode("div", _hoisted_32, [
                      (_ctx.property.year_built)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "font-medium mr-2" }, "Year Built:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.year_built), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.availability_date)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "font-medium mr-2" }, "Available From:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.property.availability_date)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.floor !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "font-medium mr-2" }, "Floor:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.floor), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.total_floors !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "font-medium mr-2" }, "Total Floors:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.total_floors), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.elevator !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "font-medium mr-2" }, "Elevator:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.elevator ? 'Yes' : 'No'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.parking)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "font-medium mr-2" }, "Parking:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.parking), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.furnished !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _cache[39] || (_cache[39] = _createElementVNode("span", { class: "font-medium mr-2" }, "Furnished:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.furnished ? 'Yes' : 'No'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.pets_allowed !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "font-medium mr-2" }, "Pets Allowed:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.pets_allowed ? 'Yes' : 'No'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.entry_type)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "font-medium mr-2" }, "Entry Type:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.entry_type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.property.utilities_included)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _cache[42] || (_cache[42] = _createElementVNode("span", { class: "font-medium mr-2" }, "Utilities Included:", -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.property.utilities_included), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
}